import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { OrgChartResponse } from "@/types/api";

export function useOrgChart(customerId: string | null) {
  return useQuery({
    queryKey: ["org-chart", customerId],
    enabled: customerId !== null,
    queryFn: ({ signal }) =>
      apiFetch<OrgChartResponse>(`/api/customers/${customerId}/org`, { signal }),
    staleTime: 10_000,
  });
}
